export default {
  advices: {
    privacy_policy: {
      title: 'Aviso de privacidad',
      description:
        'Este mensaje puede contener información confidencial o datos de carácter personal. Si no es el destinatario indicado o el responsable de su entrega, no revele, copie, distribuya o use este mensaje. Por favor comunique su recepción y elimínelo. ALEGRA declina cualquier responsabilidad por las alteraciones que pudieran hacerse del mensaje una vez enviado. Informamos de que ALEGRA SOLUCIONES, S.L. (“ALEGRA”) tratará los datos personales de este mensaje y los que formen parte de su cadena, como Responsable, con la finalidad de mantener la comunicación electrónica. No serán comunicados a ninguna otra persona o entidad, salvo que una obligación legal, judicial o administrativa así lo exija. Podrá ejercer sus derechos enviando correo electrónico a soporte@usuarios.alegra.com, o dirigiendo una carta a Avenida Sabino Arana, 8, Piso 2, 48013, Bilbao, Bizkaia, incluyendo como referencia "Ejercicio de Derechos". Más información en: <a href="https://www.alegra.com/es/" target="_blank" class="text-sm-primary-500 underline">Alegra España.</a>',
    },
  },
  new_support_model: {
    wizard_steps: {
      step1: 'Descripción de tu inquietud',
      step2: 'Ayudas relacionadas',
      step3: 'Opciones de contacto',
    },
    described_inquery: {
      title: 'Hola, {{name}}, ¿cómo podemos ayudarte?',
      title_without_name: 'Hola, ¿cómo podemos ayudarte?',
      subtitle: 'Describe tu inquietud de forma general y te ayudaré a resolverla.',
      cta_btn: 'Continuar',
    },
    relationated_helps: {
      title: 'Ayudas relacionadas',
      subtitle:
        'Algunas personas con una inquietud similar encontraron solución en uno de los siguientes artículos:',
      tabs_label: {
        all: 'Todos',
        article: 'Artículos',
        video: 'Videos',
        community: 'Foro comunitario',
      },
      support_card: {
        title: '¿Sigues sin resolver tu inquietud?',
        description: 'Explora tus opciones de soporte y ponte en contacto con nuestro equipo.',
        cta_btn: 'Ver opciones de soporte',
      },
    },
    contact_options: {
      title: 'Opciones de contacto',
      subtitle: 'Estas son las opciones de soporte disponibles para tu plan',
      subtitle_acc: 'Estas son las opciones de soporte disponibles para ti',
      support_options: {
        chat: {
          title: 'Habla con un agente por chat',
          description_sales:
            'Disponible de lunes a viernes de 8:00am a 12:00pm y de 2:00pm a 5:30pm Colombia',
          description_sales_acc:
            'Disponible de lunes a viernes de 8:00am a 12:00pm y de 2:00pm a 5:30pm Colombia',
          description: 'Disponible de lunes a viernes de 8:00am a 5:30pm',
          description_acc: 'Disponible de lunes a viernes durante todo el día',
          description_enterprise:
            // 'Disponible de lunes a viernes de 8:00am a 5:30pm y los sábados de 8:00am a 12:30pm <strong>hora colombiana</strong>',
            'Disponible de lunes a viernes de 3:00pm a 12:30am y los sábados de 8:00am a 12:30pm',
        },
        try_chat: {
          title: 'Habla con un agente por chat',
          description_sales:
            // 'Disponible de lunes a viernes de 8:00am a 12:00pm y de 2:00pm a 5:30pm <strong>hora colombiana</strong>',
            'Disponible de lunes a viernes de 3:00pm a 7:00pm y de 9:00pm a 12:30am <span style="color: #4F46E5;">¡Prueba gratis durante 15 días!</span>',
          description:
            'Disponible de lunes a viernes de 8:00am a 5:30pm <span style="color: #4F46E5;">¡Prueba gratis durante 30 días!</span>',
        },
        group_training: {
          title: 'Agenda una capacitación grupal',
          description: 'Únete a una sesión grupal y amplía tus conocimientos en comunidad.',
        },
        individual_advice: {
          title: 'Agenda una asesoría individual',
          description:
            'Selecciona el horario que mejor se ajuste a tus necesidades y disponibilidad.',
        },
        send_email: {
          title: 'Envía un correo',
          description:
            'Nuestra bandeja de entrada está <strong>disponible las 24 horas</strong> para resolver tus dudas.',
          step1: {
            subtitle:
              'Déjanos tu duda o consulta por aquí, y pronto un agente te ayudará a resolver tu caso.',
            file: {
              label:
                '¿Tienes capturas, documentos o imágenes? Cárgalas aquí, esto nos ayudará a identificar tu problema.',
              hint: 'Solo archivos JPG or PNG menores a 500mb',
            },
          },
          message_final: {
            title: '¡Correo enviado!',
            message: 'Nos pondremos en contacto muy pronto.',
            advice: 'Si no encuentras el correo, busca en la carpeta de Promociones o Spam.',
          },
        },
        whatsapp: {
          title: 'Escríbenos por WhatsApp',
          description:
            'Obtén asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          description_sales:
            'Obtén asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
          description_sales_acc:
            'Obtén asistencia personalizada a través de WhatsApp. Disponible de lunes a viernes de 8:00 a.m. a 5:30 p.m.',
        },
        call_agent: {
          title: 'Llama a un agente de soporte',
          description: 'Disponible de lunes a viernes de 9:00 a.m. a 2:00 p.m.',
          description_sales:
            'Agenda una llamada con un agente de soporte para resolver tu inquietud.',
          message_final: {
            title: 'Llama al {{phone}} para hablar con un agente de soporte',
            message: 'Disponible de lunes a viernes de 9:00 a.m. a 2:00 p.m.',
          },
        },
        comunity_forum: {
          title: 'Consulta en el foro comunitario',
          description: 'Haz preguntas y obtén respuestas de la comunidad de usuarios de Alegra.',
        },
      },
      banner_upsell: {
        title: 'Accede a más opciones de soporte',
        description:
          'Mejora tu plan y ten acceso a más canales de soporte para recibir ayuda especializada cuando la necesites',
        ctas_btn: {
          upgrade: 'Actualizar plan',
          contact: 'Hablar con ventas',
          contact_support: 'Hablar con soporte',
        },
        modals: {
          contact: {
            title: 'Llama a un agente de Alegra',
            message_final: {
              title: 'Llama al {{phone}} y contacta a {{agent}}',
              message:
                'Disponible de lunes a viernes de 8:00 a.m. a 12:00 m. y de 2:00 p.m. a 5:30 p.m.',
            },
          },
        },
      },
    },
  },
}
